import { Component, signal } from '@angular/core';
import { Asset } from 'app/classes/asset';
import { Org } from 'app/classes/org';
import { APIService } from 'app/shared/api.service';

@Component({
  selector: 'app-energy-home',
  templateUrl: './energy-home.component.html',
  styleUrl: './energy-home.component.css',
  standalone: false
})
export class EnergyHomeComponent {

  asset = signal<Asset>(null);
  org: Org;
  constructor(private apiService: APIService) {
    //  assetService.getAsset(24768).then(a => this.asset.set(a));
    this.org = apiService.getUserOrg();
  }

}
